module.exports = __webpack_public_path__ + "static/media/FlightLogs.0ab8be80.svg";